import React, { useState, useEffect } from "react";
import LoggedNav from "../components/LoggedNav";
import { isMobile } from "react-device-detect";
import Spinner from "./BePatient";
import { RiArrowLeftSLine } from 'react-icons/ri';
import { useNavigate } from "react-router-dom";
import PopUp from "../components/Popup";
import { apiCall, getJsonResponse } from '../utils/apiUtils';

function OrderDetail(props) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  let total_amount = 0;
  total_amount = parseFloat(total_amount) + (details.grocery_bill_details && details.grocery_bill_details.grocery_amount ? parseFloat(details.grocery_bill_details.grocery_amount) : 0);
  total_amount = parseFloat(total_amount) + (details.tips_amount ? parseFloat(details.tips_amount) : 0);
  let navigate = useNavigate();

  const updateDetails = async () => {
    setLoading(true);
    let data = await apiCall(
      `${process.env.REACT_APP_BASE_URL}book/customer_booking_details`,
      {
        method: "POST",
        body: JSON.stringify({
          booking_id: localStorage.getItem("booking_id").toString(),
        }),
      }
    );
    let parsedData = await getJsonResponse(data);
    if (!parsedData.status) {
      navigate("/order-list");
    }
    setDetails(parsedData.data[0]);
    setLoading(false);
  };

  useEffect(() => {
    var title = "Order Detail | CHEF REPUBLIC";
    var desc = "Customer can view the order details on the private Chefs profile that he has select including status of the order.";
    const titleTag = document.querySelector('title');
    titleTag.innerText = title;
    const metaTitle = document.querySelector("meta[name='title']");
    metaTitle.setAttribute('content', title);
    const metaDescription = document.querySelector("meta[name='description']");
    metaDescription.setAttribute('content', desc);
    const metaTitleOG = document.querySelector("meta[property='og:title']");
    metaTitleOG.setAttribute('content', title);
    const metaDescriptionOG = document.querySelector("meta[property='og:description']");
    metaDescriptionOG.setAttribute('content', desc);
    const metaTitleTwitter = document.querySelector("meta[property='twitter:title']");
    metaTitleTwitter.setAttribute('content', title);
    const metaDescriptionTwitter = document.querySelector("meta[property='twitter:description']");
    metaDescriptionTwitter.setAttribute('content', desc);

    updateDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    loading ? <Spinner /> : <>
      <LoggedNav customer={props.customer} redirect_to={"/order-list"} />
      {isMobile ? null : <div className="container mt-5">
        <a onClick={() => { navigate("/order-list"); }} style={{ textDecoration: "none", color: "black", fontWeight: 500, cursor: "pointer" }}>
          <RiArrowLeftSLine size={"2rem"} />Go Back
        </a>
      </div>}
      <div className="container mt-1 border border-0 ">
        <div
          className="d-flex justify-content-center flex-column align-items-center mb-5"
          style={{
            width: isMobile ? "100%" : "60%",
            margin: "auto",
            height: "auto",
            background: "#FFFFFF",
            boxShadow: isMobile ? "" : "0px 0px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "20px",
          }}
        >
          <div className="py-5 row" style={{ width: isMobile ? "95%" : "60%", }}>
            <div className="col-2">
              <img src={details.booked_chef_profile_image} style={{ width: "50px", height: "50px", borderRadius: "50%" }} alt="" />
            </div>
            <div className="col-10">
              <h6 style={{ fontWeight: 800 }}>
                {details.booked_chef}
              </h6>
              <span
                className=""
                style={{
                  fontSize: "0.7rem",
                  color: "white",
                  background: localStorage.getItem(details.booking_status),
                  borderRadius: "20px",
                  padding: "3px 15px",
                  fontWeight: 700,
                }}
              >
                {details.booking_status}
              </span>
              <p className="my-2" style={{ fontSize: "0.9rem" }}>ORDER ID: {details.booking_order_id}</p>
              <p className="" style={{ fontSize: "0.7rem" }}>{details.booked_on}</p>
            </div>
          </div>

          <div className="form_box" style={{ width: isMobile ? "95%" : "86%", margin: "auto" }}>
            <div
              className="box_title py-2 my-2"
              style={{
                background: "#FFFFFF",
                boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "15px",
                width: "100%",
                margin: "auto",
              }}
            >
              <div className="mx-3 fw-bold">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Address for service
                </label>
              </div>
              <div className="mx-3">
                <p>{details.booking_address}</p>
              </div>
              {details.postal_code &&
                <div className="mx-3">
                  <hr />
                  <label className="form-label fw-bold small">{`Specific Zip Code: ${details.postal_code ?? '--'}`}</label>
                </div>}
            </div>

            <div
              className="box_title py-2 my-2"
              style={{
                background: "#FFFFFF",
                boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "15px",
                width: "100%",
                margin: "auto",
              }}
            >
              <div className="mx-3 fw-bold">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Date Selected
                </label>
              </div>
              <div className="mx-3">
                <p>{details.booking_date}</p>
              </div>
            </div>

            <div
              className="box_title py-2 my-2"
              style={{
                background: "#FFFFFF",
                boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "15px",
                width: "100%",
                margin: "auto",
              }}
            >
              <div className="fw-bold mx-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Timeslot Selected
                </label>
              </div>
              <div className="mx-3">
                <p>{details.booking_time}</p>
              </div>
            </div>

            <div
              className="box_title py-2 my-2"
              style={{
                background: "#FFFFFF",
                boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "15px",
                width: "100%",
                margin: "auto",
              }}
            >
              <div className=" fw-bold mx-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Cuisine/Diet Selected
                </label>
              </div>
              <div className="mx-3">
                <p>{details.booking_category}</p>
              </div>
            </div>

            {details.menu_items && details.menu_items.length > 0 ? <div className="row my-4">
              <div className="col-7"><h6 className="fw-bold text-nowrap">Enter menu item number</h6></div>
              <div className="col-1"></div>
              <div className="col-4 text-center"><h6 className="fw-bold text-nowrap">Portion Size</h6></div>
              {details.menu_items.map((element, index) => {
                return <div className="row my-1" key={index} >
                  <div className="col-7">
                    <input
                      type="number"
                      className="form-control shadow-none"
                      placeholder={element.item_number}
                      defaultValue={element.item_number}
                      disabled={true}
                    />
                  </div>
                  <div className="col-1"></div>
                  <div className={isMobile ? "col-4 d-flex justify-content-end" : "col-4 d-flex justify-content-center"}>
                    <select defaultValue={element.portion} disabled={true}>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>;
              })}
            </div> : null}

            <div className="mb-3">
              <label htmlFor="Input" className="form-label fw-bold">
                Please state your allergies, if any
              </label>
              <input
                type="text"
                className="form-control"
                id="Input"
                style={{
                  borderRadius: "15px",
                  backgroundColor: "rgba(128, 128, 128,0.4)",
                }}
                placeholder={details.allergies}
                disabled={true}
              />
            </div>

            {/* <div className="mb-3">
              <label htmlFor="Input" className="form-label fw-bold">
                Do you want the chef to pick up groceries?
              </label> <br />
              <label>Grocery delivery fees is $14.99</label>
              <div className="d-flex mt-1 justify-content-evenly">
                <button key="1" type="button" className={details.is_grocery_pickup === "yes" ? "btn-orange-disabled mx-1 w-100" : "btn-white-disabled mx-1 w-100"} disabled="disabled">
                  Yes
                </button>
                <button type="button" className={details.is_grocery_pickup === "yes" ? "btn-white-disabled mx-1 w-100" : "btn-orange-disabled mx-1 w-100"} disabled="disabled">
                  No
                </button>
              </div>
            </div> */}

            <div className="mb-3">
              <label htmlFor="Input" className="form-label fw-bold">
                Add instructions for the Chef{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="Input"
                style={{
                  borderRadius: "15px",
                  backgroundColor: "rgba(128, 128, 128,0.4)",
                }}
                disabled={true}
                placeholder={details.instructions_for_chef}
              />
            </div>

            {details.grocery_bill_details && details.grocery_bill_details.grocery_bill ? <><div className="my-5 text-center">
              <button
                type="button"
                className="btn-orange text-center"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                View Grocery Bill
              </button>
            </div>
              <PopUp img={details.grocery_bill_details.grocery_bill} /></> : null}

            {/* ------------------------------- DYNAMIC INVOICE RENDERING (Meal Prep Complete) ------------------------------- */}
            {(details.payment_details || details.invoice_details) && details.booking_status === "Meal Prep Complete" ? (
              <div
                className="box_title my-5 d-flex flex-column justify-content-center py-3 mb-3"
                style={{
                  background: "#FFFFFF",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "15px",
                }}
              >
                <h6 className="fw-bold text-center">Total Bill</h6>
                <table style={{ width: "80%", margin: "auto" }}>
                  <tbody>
                    {details.invoice_details ? (
                      // ✅ DYNAMIC: render each key from invoice_details (skip zero/null)
                      Object.entries(details.invoice_details).map(([key, rawValue]) => {
                        const parseCurrencyValue = (val) => {
                          if (val === null || val === undefined || val === "") return NaN;
                          if (typeof val === "number") return val;
                          const cleaned = val.toString().replace(/[^0-9.-]/g, "");
                          const parsed = parseFloat(cleaned);
                          return isNaN(parsed) ? NaN : parsed;
                        };
                        const amount = parseCurrencyValue(rawValue);
                        if (isNaN(amount) || amount === 0) return null;

                        const labelMap = {
                          service_amount: "Service Amount",
                          tip_received: "Tip For Chef",
                          total_amount: "Total Payment After Meal",
                          base_charge: "Base Charge",
                          grocery_fees: "Grocery Delivery Fee",
                          service_fees: "Service Fee",
                          grocery_amount: "Grocery Bill Reimbursement",
                          tip_amount: "Tip For Chef",
                          cancellation_fees: "Cancel Fee",
                          paypal_fee: "PayPal Fee",
                          net_amount: "Net Amount"
                        };
                        const displayLabel = labelMap[key] || key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
                        const isTotal = key === "total_amount";

                        return (
                          <tr key={key}>
                            <td align="left" style={{ fontSize: "0.9rem", fontWeight: isTotal ? "bold" : "normal" }}>
                              {displayLabel}
                            </td>
                            <td align="right" style={{ fontSize: "0.9rem", fontWeight: isTotal ? "bold" : "normal" }}>
                              ${Math.abs(amount).toFixed(2)}
                            </td>
                           </tr>
                        );
                      })
                    ) : (
                      // 🔁 FALLBACK: old payment_details logic (unchanged)
                      details.payment_details ? (
                        <>
                          {Array.isArray(details.payment_details) ? (
                            details.payment_details.map((element) => {
                              total_amount = parseFloat(total_amount) + (element.base_charge ? parseFloat(element.base_charge) : 0);
                              return element.base_charge ? (
                                <tr key="base_charge">
                                  <td align="left" style={{ fontSize: "0.9rem" }}>Base Charge</td>
                                  <td align="right" style={{ fontSize: "0.9rem" }}>${parseFloat(element.base_charge).toFixed(2)}</td>
                                </tr>
                              ) : null;
                            })
                          ) : typeof details.payment_details === 'object' ? (
                            <>
                              {details.payment_details.base_charge && (
                                <tr key="base_charge">
                                  <td align="left" style={{ fontSize: "0.9rem" }}>Base Charge</td>
                                  <td align="right" style={{ fontSize: "0.9rem" }}>${parseFloat(details.payment_details.base_charge).toFixed(2)}</td>
                                </tr>
                              )}
                              {details.payment_details.grocery_fees && details.is_grocery_pickup === "yes" && (
                                <tr key="grocery_fees">
                                  <td align="left" style={{ fontSize: "0.9rem" }}>Grocery Delivery Fee</td>
                                  <td align="right" style={{ fontSize: "0.9rem" }}>${parseFloat(details.payment_details.grocery_fees).toFixed(2)}</td>
                                </tr>
                              )}
                            </>
                          ) : null}
                          {details.grocery_bill_details?.grocery_amount ? (
                            <tr>
                              <td align="left" style={{ fontSize: "0.9rem" }}>Grocery Bill Reimbursement</td>
                              <td align="right" style={{ fontSize: "0.9rem" }}>${parseFloat(details.grocery_bill_details.grocery_amount).toFixed(2)}</td>
                            </tr>
                          ) : null}
                          {details.tips_amount ? (
                            <tr>
                              <td align="left" style={{ fontSize: "0.9rem" }}>Tip For Chef</td>
                              <td align="right" style={{ fontSize: "0.9rem" }}>${parseFloat(details.tips_amount).toFixed(2)}</td>
                            </tr>
                          ) : null}
                          <tr>
                            <td align="left" style={{ fontSize: "0.9rem" }} className="fw-bold pt-2">Total Payment After Meal</td>
                            <td align="right" style={{ fontSize: "0.9rem" }} className="fw-bold pt-2">${parseFloat(total_amount).toFixed(2)}</td>
                          </tr>
                        </>
                      ) : null
                    )}
                  </tbody>
                </table>
              </div>
            ) : null}

            {/* ------------------------------- INVOICE FOR CANCELED STATUS (unchanged) ------------------------------- */}
            {details.invoice_details && details.booking_status === "Canceled" ? (
              <div
                className="box_title my-5 d-flex flex-column justify-content-center py-3 mb-3"
                style={{
                  background: "#FFFFFF",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "15px",
                }}
              >
                <h6 className="fw-bold text-center">Total Bill</h6>
                <table style={{ width: "80%", margin: "auto" }}>
                  <tbody>
                    <tr>
                      <td align="left" style={{ fontSize: "0.9rem" }}>Base Charge</td>
                      <td align="right" style={{ fontSize: "0.9rem" }}>${details.invoice_details.base_charge.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="left" style={{ fontSize: "0.9rem" }}>Grocery Delivery Fee</td>
                      <td align="right" style={{ fontSize: "0.9rem" }}>${details.invoice_details.grocery_fees.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="left" style={{ fontSize: "0.9rem" }}>Grocery Bill Reimbursement</td>
                      <td align="right" style={{ fontSize: "0.9rem" }}>${details.invoice_details.grocery_amount.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="left" style={{ fontSize: "0.9rem" }}>Cancel Fee</td>
                      <td align="right" style={{ fontSize: "0.9rem" }}>${details.invoice_details.cancellation_fees.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="left" style={{ fontSize: "0.9rem" }} className="fw-bold pt-2">Total Paid</td>
                      <td align="right" style={{ fontSize: "0.9rem" }} className="fw-bold pt-2">${details.invoice_details.total_amount.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}

            <p className="text-center py-4" style={{ fontSize: "0.8rem" }}>
              <a
                href="mailto:support@chefrepublic.us"
                className="text-danger"
                style={{ textDecoration: "none", color: "orange" }}
              >
                Contact us
              </a>
            </p>

            <div className="edit_btn my-4 text-center">
              {props.customer ? (
                <>
                  {(details.booking_status === "Requested" || details.booking_status === "Hired") ? (
                    <button
                      onClick={() =>
                        navigate("/booking-detail/cancel", {
                          state: {
                            chef_name: details.booked_chef,
                            chef_profile_image: details.booked_chef_profile_image,
                            chef_id: details.chef_id,
                            bookingId: details.booking_id,
                            booking_status: details.booking_status,
                          },
                        })
                      }
                      className="btn btn-white rounded-pill mb-3 "
                      style={{ width: "90%" }}
                    >
                      Cancel Booking
                    </button>
                  ) : details.booking_status === "Meal Prep Complete" ? (
                    <>
                      {details.tips_given === "0" && details.review_given === "0" ? (
                        <>
                          <button
                            onClick={() =>
                              navigate("/tip-amount", {
                                state: {
                                  chef_name: details.booked_chef,
                                  chef_profile_image: details.booked_chef_profile_image,
                                  booking_id: details.booking_id,
                                  booking_status: details.booking_status,
                                },
                              })
                            }
                            className="btn btn-orange rounded-pill mb-3 "
                            style={{ width: "90%" }}
                          >
                            Add Tip
                          </button>
                          <button
                            onClick={() =>
                              navigate("/rate-chef", {
                                state: {
                                  chef_name: details.booked_chef,
                                  chef_profile_image: details.booked_chef_profile_image,
                                  chef_id: details.chef_id,
                                  booking_status: details.booking_status,
                                  booking_id: details.booking_id,
                                },
                              })
                            }
                            className="btn btn-orange rounded-pill mb-3 "
                            style={{ width: "90%" }}
                          >
                            Rate Chef
                          </button>
                        </>
                      ) : details.tips_given === "0" && details.review_given !== "0" ? (
                        <button
                          onClick={() =>
                            navigate("/tip-amount", {
                              state: {
                                chef_name: details.booked_chef,
                                chef_profile_image: details.booked_chef_profile_image,
                                booking_id: details.booking_id,
                                booking_status: details.booking_status,
                              },
                            })
                          }
                          className="btn btn-orange rounded-pill mb-3 "
                          style={{ width: "90%" }}
                        >
                          Add Tip
                        </button>
                      ) : details.tips_given !== "0" && details.review_given === "0" ? (
                        <button
                          onClick={() =>
                            navigate("/rate-chef", {
                              state: {
                                chef_name: details.booked_chef,
                                chef_profile_image: details.booked_chef_profile_image,
                                chef_id: details.chef_id,
                                booking_status: details.booking_status,
                                booking_id: details.booking_id,
                              },
                            })
                          }
                          className="btn btn-orange rounded-pill mb-3 "
                          style={{ width: "90%" }}
                        >
                          Rate Chef
                        </button>
                      ) : null}
                    </>
                  ) : null}
                </>
              ) : (
                <button
                  type="button"
                  className="btn btn-orange rounded-pill mb-3 "
                  style={{ width: "90%" }}
                >
                  Cancel Booking
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderDetail;